import * as yup from "yup";

export const addCanvasSchema = yup.object().shape({
  type: yup
    .string()
    .oneOf(["thinkSpace", "analytics"], "Choose ThinkSpace or Analytics")
    .required("Canvas type is required"),
  name: yup
    .string()
    .required("Name is required")
    .min(1, "Name is required")
    .max(100, "Name must be less than 100 characters"),
  tags: yup.array().of(yup.string()).max(10, "Maximum 10 tags"),
});

export type AddCanvasFormData = {
  type: "thinkSpace" | "analytics";
  name: string;
  tags: string[];
};
